/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { SitefinityContentService } from './settings/sitefinity-content.service';
import { IDashboard } from 'src/app/model/sitefinity/IDashboard';
import { IFileAClaim } from 'src/app/model/sitefinity/IFileAClaim';

/**
 * @deprecated This class should no longer be used for new development. Please find
 * alternative places to add your code to. This class was used to access Sitefinity
 * content that was set up in the old way PGH did Sitefinity where each page had its
 * own content type / module in Sitefinity. Our current direction is to move away
 * from that and instead use the "Portal Content", "Portal Menus", "Portal Resources",
 * "Portal Settings", etc... to input content into Sitefinity. So we shouuldn't use
 * this class anymore.
 */
@Injectable({
  providedIn: 'root'
})
export class SitefinityService {

  private sitefinityMiddleWareUrl: string;
  private sfSite: string;

  constructor(
    private httpClient: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    private sitefinityContentService: SitefinityContentService
  ) {
    const middleWareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    const sitefinityMiddlewarePath = this.preInitSettingsService.getSettings().sitefinityCms.sitefinityMiddleWare;
    this.sitefinityMiddleWareUrl = middleWareUrl + sitefinityMiddlewarePath;
    this.sfSite = this.preInitSettingsService.getSiteSettings().id;
  }

  getDashboardPage(): Promise<IDashboard> {
    if (!this.sitefinityContentService.getSettings().sitefinityConfiguration.DashboardPage || !this.sitefinityContentService.getSettings().sitefinityConfiguration.DashboardPage.length) {
      return Promise.resolve(null);
    }
    return this.httpClient.get<IDashboard>(
      `${this.sitefinityMiddleWareUrl}/dashboardpages?id=${this.sitefinityContentService.getSettings().sitefinityConfiguration.DashboardPage[0]?.Id}&sf_site=${this.sfSite}&sf_provider=${this.sitefinityContentService.getSettings().sitefinityConfiguration.DashboardPage[0]?.Provider}`,
    )
      .pipe(
        catchError((err) => {
          throw new Error('Error in getDashboardPage' + err);
        })
      ).toPromise();
  }

  getFileAClaimPage(): Promise<IFileAClaim> {
    if (!this.sitefinityContentService.getSettings().sitefinityConfiguration.FileAClaimPage || !this.sitefinityContentService.getSettings().sitefinityConfiguration.FileAClaimPage.length) {
      return Promise.resolve(null);
    }
    return this.httpClient.get<IFileAClaim>(
      `${this.sitefinityMiddleWareUrl}/fileaclaimpage?id=${this.sitefinityContentService.getSettings().sitefinityConfiguration.FileAClaimPage[0]?.Id}&sf_site=${this.sfSite}&sf_provider=${this.sitefinityContentService.getSettings().sitefinityConfiguration.FileAClaimPage[0]?.Provider}`,
    )
      .pipe(
        catchError((err) => {
          throw new Error('Error in getFileAClaimPage' + err);
        })
      ).toPromise();
  }
}
